import { appInfoSelector } from '@common/redux/selectors/app';
import { AppVersion } from 'click-types';
import { pick } from 'lodash';
import { StyleSheet } from 'react-native';
import { useSelector } from 'react-redux';

const createStyles = (attributes: any) => {
  const appInfo = useSelector(appInfoSelector);

  let position;

  if (appInfo?.version === AppVersion.V4) {
    position = pick(attributes.style, [
      'left',
      'top',
      'right',
      'bottom',
      'position',
      'width',
      'height',
      'transform',
    ]);
  } else {
    position = pick(attributes, ['marginTop', 'marginLeft', 'width']);
  }

  return StyleSheet.create({
    container: {
      ...position,
      // Use exact height when clipContent is true, otherwise use minHeight
      ...(attributes.clipContent
        ? { height: attributes.height }
        : { minHeight: attributes.height }),
      zIndex: attributes.zIndex,
    },
  });
};

export default createStyles;
